// Filters
// --------------------------------------------------------
import {orderBy} from 'lodash'
import api from '@/lib/api'
import {getSorter} from '@/lib/sortOptions'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'

const getDateDiffFromState = date => {
  switch (date) {
    case '1W':
      return 7
    case '1M':
      return 30
    case '3M':
      return 90
    case '1Y':
      return 365
  }
}
const state = {
  favorites: false,
  date: null,
  types: [],
  status: [],
  axesStatus: [],
  orderBy: 'activity'
}

const getters = {
  insightsAxes: (state, getters, rootState, rootGetters) => {
    let insights = rootGetters['insights/insights']
    if (!insights) return []
    if (state.axesStatus.length > 0) {
      insights = insights.filter(insight =>
        state.axesStatus.includes(insight.status)
      )
    }
    // Sort ??
    // const sorter = getSorter(state.orderBy)
    // return orderBy(insights, sorter.field, sorter.order)
    return insights
  },
  data: (state, getters, rootState, rootGetters) => {
    let insights = rootGetters['insights/insights']
    if (!insights) return []
    if (state.date) {
      const today = new Date()
      const diff = getDateDiffFromState(state.date)
      insights = insights.filter(
        insight => differenceInCalendarDays(today, insight.createdAt) <= diff
      )
    }
    if (state.favorites) {
      insights = insights.filter(insight => insight.currentUser.favorited)
    }
    if (state.types.length > 0) {
      insights = insights.filter(insight => state.types.includes(insight.type))
    }
    if (state.status.length > 0) {
      insights = insights.filter(insight =>
        state.status.includes(insight.status)
      )
    }
    // Sort
    const sorter = getSorter(state.orderBy)
    return orderBy(insights, sorter.field, sorter.order)
  },
  selectedTypes: state => state.types,
  selectedStatus: state => state.status,
  selectedAxesStatus: state => state.axesStatus,
  favorites: state => state.favorites,
  date: state => state.date,
  orderBy: state => state.orderBy
}

const mutations = {
  reset(state) {
    state.favorites = false
    state.date = null
    state.types = []
    state.status = []
    state.axesStatus = []
    state.orderBy = 'activity'
  },
  favorites(state, selected) {
    state.favorites = !!selected
  },
  date(state, date) {
    state.date = date
  },
  typesPut(state, types) {
    state.types = types
  },
  statusPut(state, status) {
    state.status = status
  },
  types(state, type) {
    if (!type) return
    const types = Array.isArray(type) ? type : [type]
    types.forEach(type => {
      const index = state.types.findIndex(_type => _type === type)
      index === -1 ? state.types.push(type) : state.types.splice(index, 1)
    })
  },
  status(state, status) {
    if (!status) return
    const statuses = Array.isArray(status) ? status : [status]
    statuses.forEach(status => {
      const index = state.status.findIndex(_status => _status === status)
      index === -1 ? state.status.push(status) : state.status.splice(index, 1)
    })
  },
  axesStatus(state, status) {
    // TODO: refactor me!
    if (!status) return
    const statuses = Array.isArray(status) ? status : [status]
    statuses.forEach(status => {
      const index = state.axesStatus.findIndex(_status => _status === status)
      index === -1
        ? state.axesStatus.push(status)
        : state.axesStatus.splice(index, 1)
    })
  },
  orderBy(state, criteria) {
    state.orderBy = criteria || state.orderBy
  }
}

const actions = {
  filterSettings({getters, rootGetters, dispatch}) {
    const statusesSettings = rootGetters['insights/settings/statuses']
    const statusesTypes = rootGetters['insights/settings/types']
    const settingsLoaded = rootGetters['insights/settings/loaded']
    if (settingsLoaded) {
      const landscapeId = rootGetters['currentLandscapeId']
      const cleanStatusFilter = getters.selectedStatus.filter(
        s => !!statusesSettings.find(setting => setting.key === s)
      )
      const cleanTypeFilter = getters.selectedTypes.filter(
        t => !!statusesTypes.find(type => type.key === t)
      )
      if (cleanStatusFilter.length !== getters.selectedStatus.length) {
        dispatch('setStatusPut', {value: cleanStatusFilter, landscapeId})
      }
      if (cleanTypeFilter.length !== getters.selectedTypes.length) {
        dispatch('setTypesPut', {value: cleanTypeFilter, landscapeId})
      }
    }
  },
  setPreferences({commit}, preferences) {
    commit('favorites', preferences.insightsFavorite)
    commit(`types`, preferences.insightsTypeFilter)
    commit('status', preferences.insightsStatusFilter)
    commit('axesStatus', preferences.insightsAxesStatusFilter)
    commit('date', preferences.insightsDateFilter)
    commit('orderBy', preferences.insightsOrderBy)
  },
  setOrderBy({commit}, {value, landscapeId}) {
    commit('orderBy', value)
    return api.call('patch', `/landscapes/${landscapeId}/preferences`, {
      insightsOrderBy: value
    })
  },
  setDate({commit}, {date, landscapeId}) {
    commit('date', date)
    return api.call('patch', `/landscapes/${landscapeId}/preferences`, {
      insightsDateFilter: date
    })
  },
  setFavorite({commit}, {value, landscapeId}) {
    commit('favorites', value)
    return api.call('patch', `/landscapes/${landscapeId}/preferences`, {
      insightsFavorite: !!value
    })
  },
  setTypes({commit, getters}, {value, landscapeId}) {
    commit('types', value)
    return api.call('patch', `/landscapes/${landscapeId}/preferences`, {
      insightsTypeFilter: getters.selectedTypes
    })
  },
  setStatus({commit, getters}, {value, landscapeId}) {
    commit('status', value)
    return api.call('patch', `/landscapes/${landscapeId}/preferences`, {
      insightsStatusFilter: getters.selectedStatus
    })
  },
  setTypesPut({commit, getters}, {value, landscapeId}) {
    commit('typesPut', value)
    return api.call('patch', `/landscapes/${landscapeId}/preferences`, {
      insightsTypeFilter: getters.selectedTypes
    })
  },
  setStatusPut({commit, getters}, {value, landscapeId}) {
    commit('statusPut', value)
    return api.call('patch', `/landscapes/${landscapeId}/preferences`, {
      insightsStatusFilter: getters.selectedStatus
    })
  },
  setAxesStatus({commit, getters}, {value, landscapeId}) {
    commit('axesStatus', value)
    return api.call('patch', `/landscapes/${landscapeId}/preferences`, {
      insightsAxesStatusFilter: getters.selectedAxesStatus
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
